/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { UserGuard } from './guards/UserGuard';
import { routes } from './router/routes';
import RouteWrapper from './router/RouteWrapper';
import { navigationAgents } from './utils/navigation-constants/navigation-partner';

const App = () => {
    const [redirectPartner, setRedirectPartner] = useState<any>();

    const token = localStorage.getItem('accessToken') || null;

    const navigation: any = navigationAgents;
    const isAuthenticated = UserGuard();

    useEffect(() => {
        if (
            navigation &&
            token &&
            (!redirectPartner || redirectPartner === '/auth')
        ) {
            const findIfInsightsExists =
                navigation &&
                navigation?.length > 0 &&
                navigation?.find((item: any) => item?.path === '/');
            if (!findIfInsightsExists) {
                const getFirstPage =
                    navigation && navigation?.length > 0 && navigation?.[0];
                setRedirectPartner(getFirstPage?.path);
            } else if (!UserGuard()) {
                setRedirectPartner('/');
            } else if (UserGuard()) {
                setRedirectPartner('/dashboard');
            }
        } else if (!token && !redirectPartner) {
            setRedirectPartner('/admin');
            // (window as any).Intercom('shutdown');
        }
    }, [navigation, token]);

    return (
        <div className="App font-inter">
            <Routes>
                {routes.map((route: any, index: number) => {
                    const children = route.childrens;
                    const guardForThisRoute = route.guard;
                    const perRouteRedirect = token
                        ? '/dashboard'
                        : '/admin';
                    const routeElement = (
                        <RouteWrapper
                            guard={guardForThisRoute}
                            redirectPath={perRouteRedirect}
                            element={route.element}
                        />
                    );

                    return children ? (
                        <React.Fragment key={index}>
                            {route.index && (
                                <Route
                                    path={route.path}
                                    element={
                                        <Navigate to={route.index} replace />
                                    }
                                />
                            )}
                            <Route path={route.path} element={routeElement}>
                                {children.map((r: any, i: number) =>
                                    r.index ? (
                                        <Route
                                            key={i}
                                            index
                                            element={
                                                <RouteWrapper
                                                    guard={
                                                        r.guard ||
                                                        guardForThisRoute
                                                    }
                                                    redirectPath={
                                                        perRouteRedirect
                                                    }
                                                    element={r.element}
                                                />
                                            }
                                        />
                                    ) : (
                                        <Route
                                            key={i}
                                            path={r.path}
                                            element={
                                                <RouteWrapper
                                                    guard={
                                                        r.guard ||
                                                        guardForThisRoute
                                                    }
                                                    redirectPath={
                                                        perRouteRedirect
                                                    }
                                                    element={r.element}
                                                />
                                            }
                                        />
                                    ),
                                )}
                            </Route>
                        </React.Fragment>
                    ) : (
                        <Route
                            key={index}
                            path={route.path}
                            element={routeElement}
                        />
                    );
                })}
                <Route
                    path="*"
                    element={
                        <Navigate
                            replace
                            to={
                                token && isAuthenticated ? '/dashboard' : '/'
                            }
                        />
                    }
                />
            </Routes>
        </div>
    );
};

export default App;
